import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['shareWithTeamModalVisible'] = false,
  action: Action,
): RootState['shareWithTeamModalVisible'] {
  switch (action.type) {
    case 'SHARE_WITH_TEAM_MODAL_VISIBLE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
